module.exports = __webpack_public_path__ + "img/portrait-012.ef526bee.jpg";